import React, { useContext, useState, useEffect, useRef } from 'react';
import { LogD } from '../../../function/LogLapper';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import { TrendManagementSettingType } from './TrendGraph';
import SimpleDialog from '../../atoms/Dialog/SimpleDialog';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';
import {
  SIG_CMP_GROUP_SET,
  GetXYComparisonGroupList,
  FFT_CMP_GROUP_SET,
  GetRealTimeTrendGroupTableByItemSet,
  RTGroupSelectDataType,
} from '../../../function/GroupDataModel';
import XYDiagramGroupSelectPage from '../XYDiagram/XYDiagramGroupSelectPage';
import RealTimeTrendGraphGroupSelectPage from '../RealTimeTrendGraph/RealTimeTrendGraphGroupSelectPage';
import { AppContext } from '../../../App';
import ImageDialog, { ImageDialogResponse } from '../../molecules/Dialog/ImageDialog';
import { useModal } from '../../../function/useModal';
import { ImageFileType, GetThreeDimensionImagePath ,GetThreeDimensionImageTitle} from '../../../function/ImageFileModel';
import { PLCcollectSettingType } from '../MeasureSetting/CollectSetting/CollectSettingDefine';

/**ダイアログ表示モードキー */
const DialogKindKey = {
  None: 'None',
  XYComparison: 'xyComparison',
  Trend: 'trend',
  RealTime: 'realTime',
} as const;
/**ダイアログ表示タイプ */
type DialgKindType = typeof DialogKindKey[keyof typeof DialogKindKey];
/**引数 */
type Props = {
  trendSettingList: TrendManagementSettingType[];
  date1: string;
  date2: string;
  date3: string;
};

const TrendGraphButtonList: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { login } = useContext(AppContext);
  const buttonStyle = {
    maxWidth: '180px',
    maxHeight: '35px',
    minWidth: '180px',
    minHeight: '35px',
  };

  const [simpleDialogOpen, setSimpleDialogOpen] = React.useState(false);
  const [gropuSelectDialogOpen, setGropuSelectDialogOpen] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState<string>('');

  const [dialogKind, setDialogKind] = React.useState<DialgKindType>(DialogKindKey.None);
  const [selectGroupNos, setSelectGroupNos] = React.useState<number[]>([0]);
  const [imagePath, setImagePath] = React.useState<string>('');
  const [imageName, setImageName] = React.useState<string>('');
  const [imageDlg, actImageDlg] = useModal<ImageDialogResponse>();
  const [imageCollectSetting, setImageCollectSetting] = React.useState<PLCcollectSettingType>();
  const [imageFileDate, setImageFileDate] = React.useState<string>('');

  //メッセージボックスタイトル
  const messageDialogTitle = React.useRef<string>(t('TrendGraphButtonList.グループ選択', 'グループ選択'));

  const imgDlg = imageDlg ? (
    <ImageDialog
      dialog={actImageDlg}
      imageName={imageName}
      imagePath={imagePath}
      imageWidht={'100%'}
      imageHeigth={'100%'}
      title={GetThreeDimensionImageTitle(imageFileDate, imageCollectSetting)}
    />
  ) : null;
  //3次元ボタン有効フラグ
  const threeDButtonEnabled: boolean = login.GetSystemSettingModel.ThreeDButtonEnabled === 1 ? true : false;
  /**
   * グループ選択ダイアログ表示
   */
  const handleGroupSelectDialogShow = () => {
    setGropuSelectDialogOpen(true);
  };

  /**
   * グループ選択ダイアログ閉じる
   */
  const handleGroupSelectDialogClose = () => {
    setGropuSelectDialogOpen(false);
  };
  /**メッセージボックス閉じる */
  const handleSimpleDialogClose = () => {
    setSimpleDialogOpen(false);
  };

  /**
   * FFT比較ボタン押下
   * @returns
   */
  const FFTComparisonPagePageOpen = () => {
    messageDialogTitle.current = t('TrendGraphButtonList.グループ選択', 'グループ選択');

    //選択項目を取得
    var target = props.trendSettingList.filter((row) => row.IsDataSelect === true);
    if (target.length === 0) {
      setShowMessage(t('TrendGraphButtonList.項目が選択されていません', '項目が選択されていません'));
      setSimpleDialogOpen(true);
      return;
    }
    console.debug(['datas', props.date1, props.date2, props.date3]);
    var dt1 = props.date1;
    var dt2 = props.date2;
    var dt3 = props.date3;
    if (dt1 === '') {
      setShowMessage(t('TrendGraphButtonList.日付が選択されていません', '日付が選択されていません'));
      setSimpleDialogOpen(true);
      return;
    }

    var sendDt: FFT_CMP_GROUP_SET = {
      GROUP_NO: -1,
      GROUP_NAME: '',
      DSP_FLG: 1,
      PLC_NO1: 0,
      SET_NO1: 0,
      PLC_NO2: 0,
      SET_NO2: 0,
      PLC_NO3: 0,
      SET_NO3: 0,
      KIND1: 0,
      KIND2: 0,
      KIND3: 0,
      Time_No1: '',
      Time_No2: '',
      Time_No3: '',
    };

    if (target.length == 1) {
      //チャンネルの選択が１個の場合、時間が違うデータを比較
      var tRow = target[0];
      if (dt1 !== '') {
        sendDt.PLC_NO1 = Number(tRow.PLCNo);
        sendDt.SET_NO1 = Number(tRow.SettingNo);
        sendDt.KIND1 = tRow.Kind;
        sendDt.Time_No1 = dt1;
      }
      if (dt2 !== '') {
        sendDt.PLC_NO2 = Number(tRow.PLCNo);
        sendDt.SET_NO2 = Number(tRow.SettingNo);
        sendDt.Time_No2 = dt2;
        sendDt.KIND2 = tRow.Kind;
      }
      if (dt3 !== '') {
        sendDt.PLC_NO3 = Number(tRow.PLCNo);
        sendDt.SET_NO3 = Number(tRow.SettingNo);
        sendDt.Time_No3 = dt3;
        sendDt.KIND3 = tRow.Kind;
      }
    } else {
      //チャンネルの選択が複数個の場合、同じ時間で比較
      if (target.length >= 1) {
        sendDt.PLC_NO1 = Number(target[0].PLCNo);
        sendDt.SET_NO1 = Number(target[0].SettingNo);
        sendDt.KIND1 = target[0].Kind;
        sendDt.Time_No1 = dt1;
      }
      if (target.length >= 2) {
        sendDt.PLC_NO2 = Number(target[1].PLCNo);
        sendDt.SET_NO2 = Number(target[1].SettingNo);
        sendDt.KIND2 = target[1].Kind;
        sendDt.Time_No2 = dt1;
      }
      if (target.length >= 3) {
        sendDt.PLC_NO3 = Number(target[2].PLCNo);
        sendDt.SET_NO3 = Number(target[2].SettingNo);
        sendDt.KIND3 = target[2].Kind;
        sendDt.Time_No3 = dt1;
      }
    }
    //画面遷移
    history.push({
      pathname: '/FFTComparisonPage',
      state: sendDt,
    });
  };

  /**
   * 3次元グラフボタン
   */
  const onClickThreeDimensionOpenButton = () => {
    messageDialogTitle.current = t('TrendGraphButtonList.3次元グラフ選択', '3次元グラフ選択');
    var target = props.trendSettingList.filter((row) => row.IsDataSelect === true);
    if (target.length === 0) {
      setShowMessage(t('TrendGraphButtonList.項目が選択されていません', '項目が選択されていません'));
      setSimpleDialogOpen(true);
      return;
    }
    if (target.length !== 1) {
      setShowMessage(
        t(
          'TrendGraphButtonList.項目選択は1つを選択後ボタン押下してください',
          '項目選択は1つを選択後，ボタン押下してください。'
        )
      );
      setSimpleDialogOpen(true);
      return;
    }

    var dt1 = props.date1;
    if (dt1 === '') {
      setShowMessage(t('TrendGraphButtonList.日付が選択されていません', '日付が選択されていません'));
      setSimpleDialogOpen(true);
      return;
    }

    console.debug(['onClickThreeDimensionOpenButton selectData , selectDate', target, dt1]);
    GetThreeDimensionImagePath(target[0].PLCNo, target[0].AICardNo, target[0].ChannelNo, dt1, 1)
      .then((r) => {
        if (r.FilePath === '') {
          setShowMessage(
            t('TrendGraphButtonList.ファイルがありません', 'ファイルがありません') + '\n' + r.SearchFileName
          );
          setSimpleDialogOpen(true);
        } else {
          setImageName(r.FilePath);
          setImagePath(`data:image/bmp;base64,${r.Base64ImageData}`);
          actImageDlg
            .open()
            .apply((resp: ImageDialogResponse) => {})
            .cancel(() => {});
          setImageCollectSetting(r.CollectSettingModel);
          setImageFileDate(r.FileDate);
        }
      })
      .catch((error) => {
        setShowMessage(
          t('TrendGraphButtonList.ファイル取得中ににエラーが発生しました', 'ファイル取得中ににエラーが発生しました')
        );
        setSimpleDialogOpen(true);
      })
      .finally(() => {});
  };

  /**
   * 生波形ボタン押下
   * @returns
   */
  const RawWaveformComparisonPageOpen = () => {
    messageDialogTitle.current = t('TrendGraphButtonList.グループ選択', 'グループ選択');

    //選択項目を取得
    var target = props.trendSettingList.filter((row) => row.IsDataSelect === true);
    if (target.length === 0) {
      setShowMessage(t('TrendGraphButtonList.項目が選択されていません', '項目が選択されていません'));
      setSimpleDialogOpen(true);
      return;
    }
    console.debug(['datas', props.date1, props.date2, props.date3]);
    var dt1 = props.date1;
    var dt2 = props.date2;
    var dt3 = props.date3;
    if (dt1 === '') {
      setShowMessage(t('TrendGraphButtonList.日付が選択されていません', '日付が選択されていません'));
      setSimpleDialogOpen(true);
      return;
    }

    var sendDt: SIG_CMP_GROUP_SET = {
      GROUP_NO: -1,
      GROUP_NAME: '',
      DSP_FLG: 1,
      PLC_NO1: 0,
      SET_NO1: 0,
      PLC_NO2: 0,
      SET_NO2: 0,
      Time_No1: '',
      Time_No2: '',
    };

    if (target.length == 1) {
      //チャンネルの選択が１個の場合、時間が違うデータを比較
      var tRow = target[0];
      sendDt.PLC_NO1 = Number(tRow.PLCNo);
      sendDt.SET_NO1 = Number(tRow.SettingNo);
      sendDt.Time_No1 = dt1;

      if (dt2 !== '') {
        sendDt.PLC_NO2 = Number(tRow.PLCNo);
        sendDt.SET_NO2 = Number(tRow.SettingNo);
        sendDt.Time_No2 = dt2;
      }
    } else {
      //チャンネルの選択が2個の場合、同じ時間で比較
      var tRow = target[0];
      var tRow2 = target[1];
      sendDt.PLC_NO1 = Number(tRow.PLCNo);
      sendDt.SET_NO1 = Number(tRow.SettingNo);
      sendDt.PLC_NO2 = Number(tRow2.PLCNo);
      sendDt.SET_NO2 = Number(tRow2.SettingNo);

      sendDt.Time_No1 = dt1;
      sendDt.Time_No2 = dt1;
    }
    //画面遷移
    history.push({
      pathname: '/RawWaveformComparisonPage',
      state: sendDt,
    });
  };
  /**
   *
   * @returns
   */
  const handleXYPageOpen = () => {
    messageDialogTitle.current = t('TrendGraphButtonList.グループ選択', 'グループ選択');

    var target = props.trendSettingList.filter((row) => row.IsDataSelect === true);
    if (target.length === 0) {
      setShowMessage(t('TrendGraphButtonList.項目が選択されていません', '項目が選択されていません'));
      setSimpleDialogOpen(true);
      return;
    } else {
      setDialogKind(DialogKindKey.XYComparison);
      GetXYComparisonGroupList().then((ret) => {
        var groupRows = ret.XY_CMP_GROUP_SETs.filter((item) => item.DSP_FLG == 1);
        var targetRows = groupRows.filter(
          (row) =>
            (row.PLC_NO_X === Number(target[0].PLCNo) && row.SET_NO_X === Number(target[0].SettingNo)) ||
            (row.PLC_NO_Y === Number(target[0].PLCNo) && row.SET_NO_Y === Number(target[0].SettingNo))
        );

        if (targetRows.length != 0) {
          var gpNos: number[] = [];
          for (var i in targetRows) {
            gpNos.push(targetRows[i].GROUP_NO);
          }
          console.debug(['targetRows,gpNos', targetRows, gpNos]);
          setSelectGroupNos(gpNos);
          handleGroupSelectDialogShow();
        } else {
          setShowMessage(
            t('TrendGraphButtonList.項目に対するグループ登録がありません', '項目に対するグループ登録がありません')
          );
          setSimpleDialogOpen(true);
        }
      });
    }
    console.debug(['handleXYPageOpen selectData', target]);
  };
  /**
   *リアルタイムトレンドボタン処理
   */
  const handleRealTimeTrendPageOpen = () => {
    messageDialogTitle.current = t('TrendGraphButtonList.グループ選択', 'グループ選択');

    setDialogKind(DialogKindKey.RealTime);
    var target = props.trendSettingList.filter((row) => row.IsDataSelect === true);

    if (target.length === 0) {
      setShowMessage(t('TrendGraphButtonList.項目が選択されていません', '項目が選択されていません'));
      setSimpleDialogOpen(true);
      return;
    }

    GetRealTimeTrendGroupTableByItemSet().then((ret) => {
      var targetRows = ret.filter(
        (r) => r.trdItemSet.PLC_NO === Number(target[0].PLCNo) && r.trdItemSet.SET_NO === Number(target[0].SettingNo)
      );
      if (targetRows.length === 0) {
        setShowMessage(
          t('TrendGraphButtonList.項目に対するグループ登録がありません', '項目に対するグループ登録がありません')
        );
        setSimpleDialogOpen(true);
        return;
      }

      //groupNoで、groupby
      console.debug(['targetRows★', targetRows]);
      var groupRows = targetRows.filter(
        (el: RTGroupSelectDataType, index, self) =>
          self.findIndex((e: RTGroupSelectDataType) => e.trdGroupSet.GROUP_NO === el.trdGroupSet.GROUP_NO) === index
      );
      console.debug(['groupRows', groupRows]);

      if (groupRows.length != 0) {
        var gpNos: number[] = [];
        for (var i in groupRows) {
          gpNos.push(groupRows[i].trdGroupSet.GROUP_NO);
        }
        setSelectGroupNos(gpNos);
        handleGroupSelectDialogShow();
      }
    });
  };

  return (
    <Grid container>
      {login.IsIoT === true ? (
        ''
      ) : (
        <Grid item xs={2}>
          <Button
            style={buttonStyle}
            variant="contained"
            color="primary"
            onClick={handleRealTimeTrendPageOpen}
            disableElevation
          >
            {t('TrendGraphButtonList.リアルタイムトレンド', 'リアルタイムトレンド')}
          </Button>
        </Grid>
      )}
      <Grid item xs={2}>
        <Button style={buttonStyle} variant="contained" color="primary" onClick={handleXYPageOpen} disableElevation>
          {t('TrendGraphButtonList.X-Y分布', 'X-Y分布')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          style={buttonStyle}
          variant="contained"
          color="primary"
          onClick={RawWaveformComparisonPageOpen}
          disableElevation
        >
          {t('TrendGraphButtonList.生波形比較', '生波形比較')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          style={buttonStyle}
          variant="contained"
          color="primary"
          onClick={FFTComparisonPagePageOpen}
          disableElevation
        >
          {t('TrendGraphButtonList.FFT比較', 'FFT比較')}
        </Button>
      </Grid>
      {threeDButtonEnabled === true ? (
        <Grid item xs={2}>
          <Button
            style={buttonStyle}
            variant="contained"
            color="primary"
            onClick={onClickThreeDimensionOpenButton}
            disableElevation
          >
            {t('TrendGraphButtonList.三次元グラフ', '三次元グラフ')}
          </Button>
        </Grid>
      ) : null}

      <SimpleDialog
        open={gropuSelectDialogOpen}
        onClose={handleGroupSelectDialogClose}
        title={t('TrendGraphButtonList.グループ選択', 'グループ選択')}
        okText={t('TrendGraphButtonList.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        {dialogKind == DialogKindKey.XYComparison ? (
          <XYDiagramGroupSelectPage defalutGropuNos={selectGroupNos} />
        ) : (
          <RealTimeTrendGraphGroupSelectPage defalutGropuNos={selectGroupNos} />
        )}
      </SimpleDialog>
      <SimpleDialog
        open={simpleDialogOpen}
        onClose={handleSimpleDialogClose}
        title={messageDialogTitle.current}
        okText={t('TrendGraphButtonList.閉じる', '閉じる')}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </SimpleDialog>
      {imgDlg}
    </Grid>
  );
};

export default TrendGraphButtonList;
